import React, { useState } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { SlArrowRightCircle } from "react-icons/sl";

const DivisionsList = ({ divisions }) => {
  const [currentView, setCurrentView] = useState({ type: "divisions" }); // 'divisions' or 'groups'
  const navigate = useNavigate();

  const handleDivisionClick = (division, targetView) => {
    if (targetView === "list") {
      setCurrentView({ type: "divisions" });
    } else {
      if (division.groups.length === 1) {
        const groupId = division.groups[0].groupId;
        navigate(`/division/${division.divisionId}/group/${groupId}`);
      } else {
        setCurrentView({
          type: "groups",
          divisionId: division.divisionId,
          divisionName: division.name,
          divisionImage: division.image,
          groups: division.groups,
        });
      }
    }
  };

  if (currentView.type === "divisions") {
    return (
      <Divisions>
        {divisions.map((division) => (
          <div
            key={division.divisionId}
            onClick={() => handleDivisionClick(division, "detail")}
          >
            <img
              src={division.image}
              alt={division.name}
              title={division.name}
              style={{ cursor: "pointer" }}
            />
          </div>
        ))}
      </Divisions>
    );
  } else if (currentView.type === "groups") {
    return (
      <Groups>
        <img
          src={currentView.divisionImage}
          alt={currentView.divisionName}
          style={{ cursor: "pointer" }}
          onClick={() => handleDivisionClick(null, "list")}
        />
        <div className="groups-list">
          {currentView.groups.map((group) => (
            <div key={group.groupId}>
              <Link
                to={`/division/${currentView.divisionId}/group/${group.groupId}`}
              >
                <button className="btn2">
                  <SlArrowRightCircle />
                  {group.name}
                </button>
              </Link>
            </div>
          ))}
        </div>
      </Groups>
    );
  }
};
const Divisions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  div img {
    width: 6rem;
    margin: 0.5rem;
    border-radius: 16px;
  }
`;

const Groups = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .groups-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  img {
    width: 4rem;
    margin: 0.5rem;
    border-radius: 16px;
  }
`;

export default DivisionsList;
